import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isInIframe, isSupplierByUrl } from "@/utils";
import styles from "./index.module.scss";
import { Tabs } from "@/components";
import { useCurrentPage } from "@/hooks";
import { SearchInput } from "../search-input";

const tabs = [
  {
    label: `找商机`,
    key: "business-opportunity",
  },
  {
    label: `找供应商`,
    key: "supplier",
  },
  // {
  //   label: `工业品`,
  //   key: "industrial-products",
  // },
  // {
  //   label: '工品管家',
  //   key: 'gongpin-guanjia',
  // }
];
export const SSearch = (props: { onTabChange?: (key: string) => void }) => {
  const [tab, setTab] = useState("supplier");
  const navigate = useNavigate();
  const setCurrentPage = useCurrentPage((state) => state.setCurrentPage);
  const turnToPage = useCurrentPage((state) => state.turnToPage);

  const isIframe = isInIframe();

  const tabArr = useMemo(() => {
    if (isIframe) {
      return tabs.filter((item) => item.key === tab);
    }
    // 生产环境去除工业品tab
    // if(process.env.GYPS_HOME !== 'https://pm-mall-test.go1688.terminus.io'){
    //   return tabs.filter((item) => item.key !== "industrial-products");
    // }
    return tabs;
  }, [isIframe, tab]);

  useEffect(() => {
    const supplierOrigin = process.env.SUPPLIER_ORIGIN;
    const currentOrigin = isIframe
      ? window.self.origin
      : window.location.origin;
    if (currentOrigin === supplierOrigin) {
      setTab("supplier");
      setCurrentPage("supplier");
    } else {
      // if(window.location.pathname.includes("/steward")){
      //   setTab("gongpin-guanjia");
      // } else {
      //   setTab("business-opportunity");
      // }
       setTab("business-opportunity");
      setCurrentPage("business-opportunity");
    }
  }, []);

  const handleTabChange = (key: string) => {
    if (tab === key) {
      return;
    }
    if (key === "business-opportunity") {
      window.location.href = `${process.env.BUSINESS_ORIGIN}/go`;
    } else if (key === "supplier") {
      window.location.href = `${process.env.SUPPLIER_ORIGIN}/s`;
    } else if (key === "industrial-products") {
      window.location.href = `${process.env.GYPS_HOME}`;
    } else if (key === "gongpin-guanjia") {
      window.location.href = `${process.env.BUSINESS_ORIGIN}/steward`;
    }
  };
  return (
    <div className={styles.sSearchWrapper}>
      <div className={styles.sSearchInner}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div className={styles.sSearchLeft}>
            <img
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logo.png"
              className={styles.sSearchLeftPng}
              style={{ cursor: "pointer" }}
              onClick={() => {
                turnToPage(navigate);
              }}
            />
          </div>
          <div className={styles.sSearchRight}>
            <Tabs
              tabs={tabArr}
              value={tab}
              onChange={handleTabChange}
              style={{ alignSelf: "center" }}
            />
            <SearchInput type="simple" selectTab={tab} />
          </div>
        </div>
        <div className={styles.sSearchLast}>
          <img
            src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/descl.png"
            className={styles.descLogo}
            alt="Logo"
          />
        </div>
      </div>
    </div>
  );
};
